var render, staticRenderFns
import script from "./SvgFilterMixin.vue?vue&type=script&lang=js&"
export * from "./SvgFilterMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9219d434')) {
      api.createRecord('9219d434', component.options)
    } else {
      api.reload('9219d434', component.options)
    }
    
  }
}
component.options.__file = "apps/settings/src/components/SvgFilterMixin.vue"
export default component.exports